var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"home-page"},[_c('Hero'),_c('SolutionsSlide'),_c('HowItWorks'),_c('Integrations'),_c('Blog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }